var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPotentialPotentialClash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 944.8818897637796 944.8818897637796",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l944.8819 0l0 944.8819l-944.8819 0l0 -944.8819z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l944.8819 0l0 944.8819l-944.8819 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p.1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(31.16403589129512 0.0 0.0 31.16403589129512 0.0 0.0)",
    spreadMethod: "pad",
    x1: -6.87648771871802,
    y1: 15.168586107574122,
    x2: 15.168586107574122,
    y2: 37.1961110031964
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ca24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f9ca24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57000005,
    stopColor: "#f6e58d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f6e58d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81000006,
    stopColor: "#fff8d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff8d1"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p.1)",
    d: "m129.07086 472.44095l0 0c0 -189.63806 153.73203 -343.3701 343.3701 -343.3701l0 0c91.06741 0 178.40494 36.17639 242.79929 100.57077c64.39441 64.39438 100.5708 151.7319 100.5708 242.79932l0 0c0 189.63803 -153.73206 343.3701 -343.3701 343.3701l0 0c-189.63806 0 -343.3701 -153.73206 -343.3701 -343.3701z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p.2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.92593742693965 0.0 0.0 33.92593742693965 0.0 0.0)",
    spreadMethod: "pad",
    x1: 17.86909635501732,
    y1: 13.935208448127067,
    x2: 41.86790639167536,
    y2: 37.914915433847845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30336b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#30336b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57000005,
    stopColor: "#4834d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4834d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81000006,
    stopColor: "#686de0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686de0"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p.2)",
    d: "m1013.15485 472.44095l0 0c0 -224.74075 182.18842 -406.92914 406.92914 -406.92914l0 0c107.92432 0 211.42834 42.872772 287.7423 119.18678c76.31409 76.31401 119.18689 179.81804 119.18689 287.74237l0 0c0 224.74075 -182.18848 406.9291 -406.9292 406.9291l0 0c-224.74072 0 -406.92914 -182.18835 -406.92914 -406.9291z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotentialPotentialClash);
export default __webpack_public_path__ + "static/media/potential_potential_clash.507a2c363a2877a5ada33c64985716b3.svg";
export { ForwardRef as ReactComponent };